import {workingCuttingMapStatuses} from "../WorkingCuttingMapStatuses";
import {structure} from "../Structure";

export const WorkingCuttingMapTableFilterData = [
    {
        "idFromColumnFilter": "number",
        "id": "number"
    },
    {
        "idFromColumnFilter": "materialName",
        "id": "materialName"
    },
    {
        "idFromColumnFilter": "optimizationQuantity",
        "id": "optimizationQuantity",
    },
    {
        "idFromColumnFilter": "optimization",
        "id": "optimization", "field": "number",
    },
    {
        "idFromColumnFilter": "numberCutting",
        "id": "numberCutting"
    },
    {
        "idFromColumnFilter": "nominalQuantity",
        "id": "nominalQuantity"
    },
    {
        "idFromColumnFilter": "orders",
        "id": "orderNumbers"
    },
    {
        "idFromColumnFilter": "materialStructure",
        "id": "materialStructure",
        "filterFn": (value, filterValue) => structure[value].toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "workingCuttingMapState",
        "id": "workingCuttingMapState",
        "filterFn": (value, filterValue) => workingCuttingMapStatuses[value].toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "note",
        "id": "note",
        "filterFn": (value, filterValue) =>
            (value ?? "").toString().toLowerCase().includes((filterValue ?? "").toString().toLowerCase()),
    },
]